/* eslint-disable class-methods-use-this, prefer-destructuring, no-undef, no-shadow, no-unused-vars */
class ExTabBoxHandler {
    constructor() {
        this.sectionExTabBox = document.querySelector('.ex-tab-box');
        if (this.sectionExTabBox) {
            this.init();
        }
    }

    init() {
        this.buttons = this.sectionExTabBox.querySelectorAll('.handler-list-item');
        this.contentBoxes = this.sectionExTabBox.querySelectorAll('.content-box');

        this.buttons.forEach(button => {
            button.addEventListener('click', () => this.handleButtonClick(button));
        });
    }

    handleButtonClick(button) {
        const index = button.getAttribute('data-index');
        
        this.buttons.forEach(btn => btn.classList.remove('active'));
        this.contentBoxes.forEach(box => box.classList.remove('active'))
        
        button.classList.add('active');
        this.sectionExTabBox.querySelector(`.content-box[data-index="${index}"]`).classList.add('active');
    }
}

export default ExTabBoxHandler;

